module.exports = __webpack_public_path__ + "static/media/phone4.ee4556c0.png";